/* GOOD BALD Theme JS */

// Header scroll effect
const header = document.getElementById('header');
if (header) {
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 50);
  });
}

// Cart Drawer
function openCartDrawer() {
  document.getElementById('cart-drawer')?.classList.add('open');
  document.getElementById('cart-overlay')?.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
  document.getElementById('cart-drawer')?.classList.remove('open');
  document.getElementById('cart-overlay')?.classList.remove('open');
  document.body.style.overflow = '';
}

// Close cart drawer on ESC
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeCartDrawer();
    document.querySelector('.mobile-nav')?.classList.remove('open');
  }
});

// Scroll animations
const observerOptions = { threshold: 0.1, rootMargin: '0px 0px -50px 0px' };
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      observer.unobserve(entry.target);
    }
  });
}, observerOptions);

document.querySelectorAll('.animate-in').forEach(el => observer.observe(el));

// Silently refresh the cart drawer HTML by refetching the current page
async function refreshCartDrawer() {
  try {
    const res = await fetch(window.location.pathname + window.location.search, { headers: { 'Accept': 'text/html' } });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('cart-drawer');
    const current = document.getElementById('cart-drawer');
    if (fresh && current) {
      const wasOpen = current.classList.contains('open');
      current.innerHTML = fresh.innerHTML;
      if (wasOpen) current.classList.add('open');
    }
  } catch (err) {
    // Silent failure — cart count is still updated
  }
}

// AJAX Add to Cart (intercept forms)
document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (form.action?.includes('/cart/add')) {
    e.preventDefault();
    
    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn.textContent;
    submitBtn.textContent = 'Adding...';
    submitBtn.disabled = true;

    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (response.ok) {
        submitBtn.textContent = 'Added ✓';

        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const countEl = document.getElementById('cart-count');
        if (countEl) countEl.textContent = cart.item_count;

        refreshCartDrawer();
      } else {
        submitBtn.textContent = 'Error';
      }
    } catch (err) {
      submitBtn.textContent = 'Error';
    }

    setTimeout(() => {
      submitBtn.textContent = originalText;
      submitBtn.disabled = false;
    }, 2000);
  }
});
